import {
  includeRule,
  excludeRule,
  hideOptionSet
}
from './rules_functions.js';

  
  
export function rules_ren(newState, state) {
  //rules with 4 conditions:
  var newrule = includeRule(newState, state, 'ren')
  var show  = hideOptionSet(newState, state, [ ['sh', ['5']]])
  if (show === true)  show  = hideOptionSet(newState, state, [ ['rset', ['UP','PR','PV']]])
  
  newrule['show']  = show
    return newrule
}


